// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"58a0d108","389":"6b3f604b","488":"f442fd7a","732":"d2c2cea9","952":"c0087359","977":"805c74d5"}[chunkId] + ".chunk.js";
};